import { Global } from '@emotion/react';
import { UserProvider } from '@libs/contexts';
import { ErrorBoundary as NonCtxErrorBoundary } from '@libs/templates/template-pages';
import { globalStyle } from '@ps-smart-cp/ppfw-client';

export function ErrorBoundary() {
  return (
    <UserProvider>
      <Global styles={globalStyle} />
      <NonCtxErrorBoundary isUnderSubsystem={false} />
    </UserProvider>
  );
}
